import { VendorInterface } from "../../models/ProcurementModule/Vendor";
import client from "../client";

class VendorService {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<VendorInterface[]>(
        `/api/Vendors/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<VendorInterface>(
        `/api/Vendors/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: VendorInterface) {
    try {
      const { data } = await client.post<VendorInterface>(
        `/api/Vendors/create`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: VendorInterface) {
    try {
      const { data } = await client.post<VendorInterface>(
        `/api/Vendors/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<VendorInterface>(
        `/api/Vendors/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new VendorService();
